import React from 'react';

export default function FieldErrors(props) {
	// console.log('FieldErrors', props);

	const { fieldName = '', fieldErrors = {} } = props;
	// console.log(fieldName, fieldErrors);

	if (fieldErrors && fieldErrors.hasOwnProperty(fieldName)) {
		return (
			<section className="field-errors">
				<div className="px-2 mt-1 error">{fieldErrors[fieldName]}</div>
			</section>
		);
	}
	return null;
}
